import { useDeferredValue } from 'react';
import useDebounce from 'customHooks/useDebounce';
import { isEqual } from 'lodash';

const useIsPending = <T>(value: T, delay = 0): [boolean, T] => {
    const deferredValue = useDeferredValue(value);
    const hasDiff = !isEqual(deferredValue, value);
    const isPending = useDebounce(hasDiff, hasDiff ? delay : 0);

    return [isPending, deferredValue];
};

export { useIsPending };
